import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isProductLoading',
    standalone: false
})
export class IsProductLoadingPipe implements PipeTransform {
  transform(loadingProductCode: string | null, productCode: string | null): number {
    if (!loadingProductCode || !productCode) {
      return 0;
    }
    
    return loadingProductCode === productCode ? 1 : 0;
  }
}